import { defineComponent as _defineComponent } from 'vue'
import { watch, ref, inject, computed, Ref, provide, readonly, onMounted } from "vue"
import PasswordFormContainer from "../PasswordForm/PasswordFormContainer.vue"
import { Step } from "../constants"
import InvitationLayout from "../shared/InvitationLayout.vue"
import { OnboardingFormValues } from "../shared/types"
import { useMutation } from "@/hooks/useMutation"
import FinalStep from "../shared/FinalStep.vue"
import {
  AcceptInvitationMutation,
  AcceptInvitationMutationMutationVariables,
  AcceptInvitationMutationMutation,
  UserInput,
} from "@/gql"
import useRouter from "@/router/useRouter"
import CheckStep from "../shared/CheckStep.vue"
import { ProductTypeEnum, AHEAD_THEME } from "@/constants"
import { useNotification } from "@/hooks/useNotification"
import NewUserForm from "../NewUserForm.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'UserInvitationFlow',
  props: {
    invitationId: null,
    email: null
  },
  setup(__props: any) {

const props = __props as { invitationId: string; email?: string }



const step = ref(Step.Password)
const stages = [Step.Password, Step.PersonalInfo, Step.Final]
const completedSteps = ref<string[]>([])
const productType = inject("productType") as Ref<ProductTypeEnum>

const isAheadClient = computed(() => productType.value === ProductTypeEnum.Ahead)

watch(step, () => (completedSteps.value = [...completedSteps.value, step.value]), {
  immediate: true,
})

const isExistingEmail = computed(() => Boolean(props.email))
const gotoNext = () => {
  const index = stages.findIndex((s) => s === step.value)
  if (index < stages.length - 1) {
    step.value = stages[index + 1]
  }
}

// const gotoPrev = () => {
//   const index = stages.findIndex((s) => s === step.value)
//   if (index > 0) {
//     step.value = stages[index - 1]
//   }
// }

const gotoFinal = () => {
  step.value = Step.Final
}

const isSubmitting = ref(false)
const { router } = useRouter()

const form = ref<OnboardingFormValues>({
  invitationId: props.invitationId,
  token: router.currentRoute.params?.token || "",
  newUserInput: {
    password: "",
    firstName: "",
    lastName: "",
    email: props.email || "",
    clientAdminPosition: "",
  },
  newClientInput: {
    name: "",
    website: "",
    countryId: "",
    address: "",
    description: "",
  },
})

// const fields = ["avatar", "email", "clientAdminPosition"]

onMounted(() => {
  provide("form", readonly(form))
})

const updateUserInput = (value: Partial<UserInput>) => {
  form.value = {
    ...form.value,
    newUserInput: {
      ...form.value.newUserInput,
      ...value,
    },
  }
}

const { mutate } = useMutation()
const { addError } = useNotification()

const onSubmit = async (values: OnboardingFormValues["newUserInput"]) => {
  if (!form.value.invitationId || !form.value.token) {
    addError("Something went wrong. Please try again.")
    return
  }

  isSubmitting.value = true
  // Mutate
  await mutate<AcceptInvitationMutationMutation, AcceptInvitationMutationMutationVariables>({
    mutation: AcceptInvitationMutation,
    variables: {
      invitationId: form.value.invitationId,
      token: form.value.token,
      newUserInput: { ...form.value.newUserInput, ...values },
    },
    onSuccess: () => {
      gotoFinal()
    },
    onMutationError: (error) => {
      addError(error.message)
    },
  })

  isSubmitting.value = false
}

const SuccessMessage = {
  ahead_business: {
    title: "Welcome to AHEAD",
    subtitle:
      "Are you ready to take your team's skills to the next level? Get started by clicking the button below.",
  },
  peralta: {
    title: "Welcome to Peralta",
    subtitle:
      "You've joined the future of work! You now have access a wide range of tools to manage your team, projects, and goals. Get started by clicking the button below.",
  },
}

return { __sfc: true,props, step, stages, completedSteps, productType, isAheadClient, isExistingEmail, gotoNext, gotoFinal, isSubmitting, router, form, updateUserInput, mutate, addError, onSubmit, SuccessMessage, PasswordFormContainer, Step, InvitationLayout, FinalStep, CheckStep, AHEAD_THEME, NewUserForm }
}

})